import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import { isPaypalSettingsOpened } from 'client/reducers/managementReducer'
import { useManagement } from 'client/store'
import {
  CommonPaypalButtonProps,
  CommonPaypalRestButton,
} from 'common/components/entities/paypal-rest-button'
import {
  TwoStepPaymentFormStep,
  TwoStepPaymentFormStepButton,
  TwoStepPaymentFormStepFooter,
} from 'common/components/entities/two-step-payment-form'
import { TwoStepPaymentFormStepInterface } from 'common/types/entities/two-step-payment-form-interface'
import React from 'react'

export interface TwoStepPaymentFormPaymentStepProps {
  entity: TwoStepPaymentFormStepInterface
  color: string
  mobileColor?: string
  backgroundColor?: string
  mobileBackgroundColor?: string
  paypal?: CommonPaypalButtonProps
}

export const TwoStepPaymentFormPaymentStep = ({
  entity,
  color,
  mobileColor,
  backgroundColor,
  mobileBackgroundColor,
  paypal,
}: TwoStepPaymentFormPaymentStepProps) => {
  const showPaypalSettings = useManagement(isPaypalSettingsOpened)

  return (
    <TwoStepPaymentFormStep>
      <ChildrenEntities
        id={entity.id}
        type={entity.type}
        childIds={entity.childIds}
      />
      {showPaypalSettings ? (
        <PayPalScriptProvider options={{ clientId: 'test' }}>
          <CommonPaypalRestButton
            backgroundColor={paypal?.backgroundColor}
            forceReRender={[paypal]}
            disabled
          />
        </PayPalScriptProvider>
      ) : (
        <React.Fragment>
          <TwoStepPaymentFormStepButton
            color={color}
            mobileColor={mobileColor}
            backgroundColor={backgroundColor}
            mobileBackgroundColor={mobileBackgroundColor}
            text={entity.buttonText}
            subText={entity.buttonSubText}
          />
          {entity.footerText && (
            <TwoStepPaymentFormStepFooter>
              {entity.footerText}
            </TwoStepPaymentFormStepFooter>
          )}
        </React.Fragment>
      )}
    </TwoStepPaymentFormStep>
  )
}
